export default __webpack_public_path__ + "static/media/SFProTextM.9f783355.woff";